import { EntityState } from '@datorama/akita';

import { ModifiedCompany } from '../../registries/companies.types';

export type CompaniesState = EntityState<ModifiedCompany>;

export function createInitialCompaniesState(): CompaniesState {
	return {};
}
